import { render, staticRenderFns } from "./Dte.vue?vue&type=template&id=554e7fa3"
import script from "./Dte.vue?vue&type=script&lang=js"
export * from "./Dte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports